import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList} from 'angularfire2/database';

@Injectable()
export class CustomerService {
    customerList : AngularFireList<any>;
  constructor(private firebase : AngularFireDatabase) { }
  getAllCustomers()
{
  this.customerList = this.firebase.list('users',ref => ref.orderByChild('role').equalTo("customer"));
  return this.customerList;
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/customers/shared/customer.service.ts